import Actions from 'reducers/Flagged'
import Release from 'models/Release'
import { FlagService, ReleasesService } from 'services'
import cloneDeep from 'lodash/cloneDeep'
import { releasePageSize } from 'config'
import { storeHelpers } from 'utils'
import type { AppDispatch } from 'types/store'

export const search = (page: number) => (dispatch: AppDispatch) => {
  dispatch(Actions.loadingFlagged())
  storeHelpers
    .asyncGetStoreState()
    .then((state: any) => {
      const { flagged: flaggedState } = state
      const params = {
        page,
        pagesize: releasePageSize,
        sort: flaggedState.sort,
      }
      ReleasesService.getFlagged(params)
        .then((response: any) => {
          let items = response.data.items
          items = items.map((item: any) => {
            const result = cloneDeep(item)
            result.publisher = Release.getPublisher(item)
            return result
          })
          const totalItemsCount = response.data.total
          dispatch(Actions.loadingFlaggedSuccess(items, page, totalItemsCount))
        })
        .catch((error: any) => {
          console.warn(error)
          dispatch(Actions.loadingFlaggedFail(error))
        })
    })
    .catch((e: any) => {
      console.warn(e)
      dispatch(Actions.loadingFlaggedFail(e))
    })
}

export const refreshList = () => (dispatch: AppDispatch) => {
  dispatch(Actions.refreshFlagged())
  dispatch(search(1) as any)
}

export const sortBy = (attribute: string) => (dispatch: AppDispatch) => {
  dispatch(Actions.sortFlaggedBy(attribute))
  dispatch(refreshList() as any)
}

export const clearAll =
  (successCallback?: () => void) => (dispatch: AppDispatch) => {
    dispatch(Actions.clearAllStart())
    FlagService.clear()
      .then(() => {
        dispatch(Actions.clearAllSuccess())
        if (successCallback) successCallback()
      })
      .catch((error: any) => {
        console.warn(error)
        dispatch(Actions.clearAllError())
      })
  }

export const flag =
  (
    releaseId: string,
    value: boolean,
    successCallback: (data?: any) => void = () => {},
    errorCallback: () => void = () => {}
  ) =>
  (dispatch: AppDispatch) => {
    if (value) {
      ReleasesService.flag(releaseId)
        .then((response: any) => {
          if (successCallback) {
            successCallback(response.data)
          }
        })
        .catch((error: any) => {
          console.warn(error)
          if (errorCallback) {
            errorCallback()
          }
        })
    } else {
      ReleasesService.unFlag(releaseId)
        .then((response: any) => {
          if (successCallback) {
            dispatch(Actions.removeFlaggedReleaseId(releaseId))
            successCallback(response.data)
          }
        })
        .catch((error: any) => {
          console.warn(error)
          if (errorCallback) {
            errorCallback()
          }
        })
    }
  }

export const flagSong =
  (
    releaseId: string,
    songId: string,
    value: boolean,
    successCallback: (data?: any) => void = () => {},
    errorCallback: () => void = () => {}
  ) =>
  () => {
    if (value) {
      ReleasesService.flagSong(releaseId, songId)
        .then((response: any) => {
          if (successCallback) {
            successCallback(response.data)
          }
        })
        .catch((error: any) => {
          console.warn(error)
          if (errorCallback) {
            errorCallback()
          }
        })
    } else {
      ReleasesService.unFlagSong(releaseId, songId)
        .then((response: any) => {
          if (successCallback) {
            successCallback(response.data)
          }
        })
        .catch((error: any) => {
          console.warn(error)
          if (errorCallback) {
            errorCallback()
          }
        })
    }
  }

export default {
  search,
  refreshList,
  sortBy,
  clearAll,
  flag,
  flagSong,
}
